import { gql } from '../../../apollo/__generated__';

export const REMOVE_BEDROOM_FROM_PLACE = gql(`
  mutation RemoveBedroomFromPlace($bedroomId: ID!) {
    removeBedroomFromPlace(bedroomId: $bedroomId) {
      id
    }
  }
`);
